
import { BrowserRouter, Route, Routes } from 'react-router';
import LandingPage from './Pages/LandingPage';
import UsuarioPage from './Pages/AfiliadoPage';
import LoginPage from './Pages/LoginPage';
import UpdateCases from './Pages/UpdateCasos';

function App() {
  return (
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/home" element={<LandingPage />} />            
          <Route path="/updateUsuario" element={<UsuarioPage />} />
          <Route path="/updateCasos" element={<UpdateCases/>} />                  
        </Routes>
      </BrowserRouter>
  );
}

export default App;